/** FounderMode (#fondateur) — the solo-founder workspace preset. */

import { useT } from '@/i18n';
import { Icon, PrimaryCta, useLandingCta } from './shared';

export function FounderMode() {
  const { t } = useT();
  const { signup } = useLandingCta();
  return (
    <section id="fondateur" className="mx-auto w-full max-w-7xl px-4 pb-16 sm:px-6 sm:pb-20 lg:px-8 lg:pb-24">
      <div className="overflow-hidden rounded-token-xl border border-border bg-surface shadow-elevation-2">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <div className="p-8 sm:p-10 lg:p-12">
            <p className="text-sm font-semibold uppercase tracking-widest text-primary">{t('routes.landing.v2.founder.eyebrow')}</p>
            <h2 className="mt-3 text-balance text-2xl font-bold tracking-tight text-foreground sm:text-3xl">
              {t('routes.landing.v2.founder.title')}
            </h2>
            <p className="mt-4 text-pretty leading-relaxed text-muted">{t('routes.landing.v2.founder.text')}</p>
            <div className="mt-6">
              <PrimaryCta onClick={() => signup()}>{t('routes.landing.v2.founder.cta')}</PrimaryCta>
            </div>
          </div>
          <div className="bg-gradient-to-br from-indigo-600 via-violet-600 to-fuchsia-600 p-8 sm:p-10 lg:p-12">
            <ul className="space-y-4">
              {(['b1', 'b2', 'b3'] as const).map((b) => (
                <li key={b} className="flex items-start gap-3 text-white">
                  <span className="mt-0.5 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-white/20">
                    <Icon name="check" className="h-4 w-4" strokeWidth={2.4} />
                  </span>
                  <span className="leading-relaxed">{t(`routes.landing.v2.founder.${b}`)}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
